var map = {
	"./anhui.json": "WrQg",
	"./aomen.json": "YJRV",
	"./beijing.json": "uMaA",
	"./chongqing.json": "Emi2",
	"./fujian.json": "03IU",
	"./gansu.json": "IdgW",
	"./guangdong.json": "DDi2",
	"./guangxi.json": "lbpA",
	"./guizhou.json": "ey7K",
	"./hainan.json": "uQfE",
	"./hainan1.json": "XDce",
	"./hebei.json": "VaCl",
	"./heilongjiang.json": "Z38A",
	"./henan.json": "Ktat",
	"./hubei.json": "4w40",
	"./hunan.json": "QbBl",
	"./jiangsu.json": "72Ub",
	"./jiangxi.json": "116Y",
	"./jilin.json": "fgtW",
	"./liaoning.json": "EcfC",
	"./neimenggu.json": "nUDj",
	"./ningxia.json": "sxN2",
	"./qinghai.json": "W5AB",
	"./shandong.json": "qbYT",
	"./shanghai.json": "1nH7",
	"./shanxi.json": "Ix0n",
	"./shanxi1.json": "FsVn",
	"./sichuan.json": "UQAV",
	"./taiwan.json": "QOTZ",
	"./tianjin.json": "nALa",
	"./xianggang.json": "KYwV",
	"./xinjiang.json": "aQJM",
	"./xizang.json": "cW8F",
	"./yunnan.json": "3jiS",
	"./zhejiang.json": "kJFr"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tBG0";